import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { noAnimation: true },
    component: () => import(/* webpackChunkName: "about" */ '@/views/login/index.vue')
  },
  // 用户中心
  {
    path: '/userCenter',
    name: 'userCenter',
    component: () => import('@/views/user-center/index.vue')
  },
  // 开始训练
  {
    path: '/startTrain',
    name: 'startTrain',
    component: () => import('@/views/startTrain/index.vue')
  },
  // 开始评估
  {
    path: '/startAssess',
    name: 'startAssess',
    component: () => import('@/views/startAssess/index.vue')
  },
  // 动画
  {
    path: '/animateAuio',
    name: 'animateAuio',
    component: () => import('@/views/animate/index.vue')
  },
  // 训练中心
  {
    path: '/trainingCenter',
    name: 'trainingCenter',
    component: () => import('@/views/trainingCenter/index.vue'),
    meta: { keepAlive: true } // 需要缓存（HMR 时由 App 主动清缓存避免白屏）
  },
  // 用户档案
  {
    path: '/userProfile',
    name: 'userProfile',
    component: () => import('@/views/userProfile/index.vue')
  },
  // 报告中心
  {
    path: '/reportCenter',
    name: 'reportCenter',
    component: () => import('@/views/reportCenter/index.vue')
  },
  // 智能评估
  {
    path: '/intelligenEvaluation',
    name: 'intelligenEvaluation',
    component: () => import('@/views/intelligenEvaluation/index.vue')
  },
  {
    path: '/assessmentScale',
    name: 'assessmentScale',
    component: () => import('@/views/assessmentScale/index.vue')
  },
  // ABC
  {
    path: '/abc',
    name: 'abc',
    component: () => import('@/views/assessmentScale/abc-topic.vue')
  },
  // cars
  {
    path: '/cars',
    name: 'cars',
    component: () => import('@/views/assessmentScale/cars-topic.vue')
  },
  // srs
  {
    path: '/srs',
    name: 'srs',
    component: () => import('@/views/assessmentScale/srs-topic.vue')
  },
  // escs智能评估
  {
    path: '/intelligenEval',
    name: 'intelligenEval',
    component: () => import('@/views/intelligenEvaluation/eval.vue')
  },
  // 眼动评估
  {
    path: '/eyeEval',
    name: 'eyeEval',
    component: () => import('@/views/intelligenEvaluation/eyeEval.vue')
  },
  // 脑电评估
  {
    path: '/eegEval',
    name: 'eegEval',
    component: () => import('@/views/intelligenEvaluation/eegEval.vue')
  },
  // 脑电检测
  {
    path: '/eegCheck',
    name: 'eegCheck',
    component: () => import('@/views/intelligenEvaluation/eegCheck.vue')
  },
  // 脑电结果
  {
    path: '/eegResult',
    name: 'eegResult',
    component: () => import('@/views/intelligenEvaluation/eegResult.vue')
  },
  // 评估顺序
  {
    path: '/evaluationOrder',
    name: 'evaluationOrder',
    component: () => import('@/views/intelligenEvaluation/evaluationOrder.vue')
  },
  // 评估报告
  {
    path: '/assessmentReport',
    name: 'assessmentReport',
    component: () => import('@/views/reportCenter/assessment-report.vue')
  },
  {
    path: '/assessmentHistory',
    name: 'assessmentHistory',
    component: () => import('@/views/reportCenter/assessment-history.vue')
  },
  // 训练报告
  {
    path: '/trainReport',
    name: 'trainReport',
    component: () => import('@/views/reportCenter/training-report.vue')
  },
  // 系统介绍
  {
    path: '/systemIntroduction',
    name: 'systemIntroduction',
    component: () => import('@/views/systemIntroduction/index.vue')
  },
  // 勋章墙
  {
    path: '/medalWall',
    name: 'medalWall',
    component: () => import('@/views/medalWall/index.vue')
  },
  // 闯关模式
  {
    path: '/quests',
    name: 'quests',
    component: () => import('@/views/quests/index.vue')
  },
  // 训练闯关模式
  {
    path: '/startTrainLevel',
    name: 'startTrainLevel',
    component: () => import('@/views/startTrainLevel/index.vue')
  },
  // 社交沟通能力训练-开始训练
  {
    path: '/startTraining',
    name: 'startTraining',
    component: () => import('@/views/trainingCenter/startTraining.vue')
  },
  // 社交沟通能力训练-训练页面
  {
    path: '/training',
    name: 'training',
    component: () => import('@/views/trainingCenter/training.vue')
  },
  // 资源中心
  {
    path: '/resourceCenter',
    name: 'resourceCenter',
    component: () => import('@/views/trainingCenter/resource-center.vue')
  },
  {
    path: '/',
    redirect: '/userCenter'
  }
]

const router = new VueRouter({
  // Electron 打包加载 file:// 时需 hash；Web 仍用 history
  mode: process.env.VUE_APP_ELECTRON === 'true' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
